import { CIcon } from '~/icons/types'

export const ciChatBubble: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 1.686c-5.93 0-10.75 4.04-10.75 9.03a8.334 8.334 0 0 0 2.8 6.07l-1.87 4.49a.736.736 0 0 0 .19.85.727.727 0 0 0 .5.19.685.685 0 0 0 .37-.1l5.26-3c1.139.322 2.316.487 3.5.49a11.865 11.865 0 0 0 7.6-2.64 8.352 8.352 0 0 0 3.15-6.37c0-4.97-4.82-9.01-10.75-9.01Zm.89 12.82H8a1 1 0 1 1 0-2h4.89a1 1 0 0 1 0 2Zm3.11-5H8a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'chat-bubble',
  type: 'solid'
}
